module.exports = __webpack_public_path__ + "static/media/kakao-over.04b82b9c.svg";